export const getUserFullName = (user: {
  firstname?: string | null;
  lastname?: string | null;
}) => {
  return user.firstname + (user.lastname ? ` ${user.lastname}` : "");
};
